<div class="height-match-parent" fxLayout="row">
  <div class="p-l-5 no-overflow no-select" fxFlex="200px">
    <div class="m-t-5 m-b-2">
      <h3 class="no-pad">{{ navtitle ?? '' | translate }}</h3>
    </div>
    <div class="nav-bar">
      @for (conf of sectionConfigs; track conf; let i = $index) {
        <recrewt-section (sectionClicked)="stepper.selectedIndex = i"
          [active]="stepper.selectedIndex === i"
          [description]="conf.description"
          [iconId]="conf.iconId"
          [title]="conf.name"
         />
      }
    </div>
    <br /><br />
    <button mat-button (click)="logout()">
      <span>{{ 'TOOLBAR.USER.logout' | translate }}</span>
    </button>
  </div>
  <div class="auto-overflow" fxFlex="grow">
    <mat-vertical-stepper #stepper class="no-stepper-header">
      @for (conf of sectionConfigs; track conf) {
        @if (conf.data.formGroup; as fg) {
          <mat-step [stepControl]="fg">
            <form [formGroup]="fg" class="no-pad">
              <recrewt-section-content [sectionType]="conf.page" />
            </form>
          </mat-step>
        } @else {
          <mat-step>
            <recrewt-section-content [sectionType]="conf.page" />
          </mat-step>
        }
      }
    </mat-vertical-stepper>
  </div>
</div>
